import { twMerge } from "tailwind-merge";

import { Avatar } from "@/components/avatar";

interface RatingUserProps {
  avatar?: string;
  className?: string;
  fallback?: string;
  name: null | string;
}

export function RatingUser({
  avatar,
  className,
  fallback = "Unassigned",
  name,
}: RatingUserProps) {
  const label = name ?? fallback;

  return (
    <span className={twMerge("inline-flex items-center gap-xs", className)}>
      <Avatar alt={label} className="size-5 rounded-full" src={avatar} />
      {label}
    </span>
  );
}
